import axios from 'axios';

// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const baseUrl = id => `/api/v1/wire/${id}/edit/`;

export function updateTitle(id, title) {
  return axios.post(`${baseUrl(id)}_update_title`, { title });
}

export function updateBody(id, body) {
  return axios.post(`${baseUrl(id)}_update_body`, { body });
}

export function updateSummary(id, summary) {
  return axios.post(`${baseUrl(id)}_update_summary`, { summary });
}

export function deleteImageById(wireId, imageId) {
  return axios.delete(`/api/v1/wire/${wireId}/image/${imageId}`);
}

export function deleteImageByBlobSignedId(wireId, signedId) {
  return axios.delete(`/api/v1/wire/${wireId}/image/blob/${signedId}`);
}

export function getWirePath(id) {
  return axios.get(`${baseUrl(id)}get_wire_path`, { cache: { ignoreCache: true } });
}

export function updateAutoPublishDate(id, date) {
  return axios.post(`${baseUrl(id)}auto_publish_at`, { value: date });
}

export function publish(id) {
  return axios.post(`${baseUrl(id)}_publish_wire`);
}

export function unpublish(id) {
  return axios.post(`${baseUrl(id)}_unpublish_wire`);
}

export function getWireSeries(wireId) {
  return axios.get(`/api/v1/wire/${wireId}/series`);
}

export function updateCollections(wireId, collectionIds) {
  return axios.post(`/api/v1/wire/${wireId}/series`, {
    collection_ids: collectionIds,
  });
}

export function generatePermaLink(id) {
  return axios.post(`${baseUrl(id)}_generate_permalink`);
}

export function updateIsSponsored(id, isSponsored) {
  return axios.post(`${baseUrl(id)}_update_is_sponsored`, { is_sponsored: isSponsored });
}

export function updateIsCommercial(id, isCommercial) {
  return axios.post(`${baseUrl(id)}_update_is_commercial`, { is_commercial: isCommercial });
}

export function updateOriginalUrl(id, url) {
  return axios.post(`${baseUrl(id)}_update_original_url`, { original_url: url });
}

export function useUpdateContributor(id) {
  const [state, q] = useAxios({
    cache: { ignoreCache: true },
    url: `${baseUrl(id)}`,
    method: 'POST',
  }, { manual: true });

  const executeQuery = (wId, slug) => q({
    url: `${baseUrl(wId)}contributor/${slug}`,
  });

  return [state, executeQuery];
}
